/* eslint-disable no-redeclare */
import type { z } from 'zod';

import { Decimal } from './decimal';

// https://aspe.hhs.gov/topics/poverty-economic-mobility/poverty-guidelines

export const FederalPovertyLevel = Decimal;

export type FederalPovertyLevel = z.infer<typeof FederalPovertyLevel>;
